import { APIFactory } from '../api/api.factory'
const AirfareAPI = APIFactory.get('airfare')

export default {
    async getAirfare(erID) {
        const { data } = await AirfareAPI.getAirfare(erID)
        return data;
    },
    async getAirlineTypes() {
        const { data } = await AirfareAPI.getAirlineTypes()
        return data;
    },
    async getNonRefundableTypes() {
        const { data } = await AirfareAPI.getNonRefundableTypes()
        return data;
    },
    async getForeignAirlineReasons() {
        const { data } = await AirfareAPI.getForeignAirlineReasons()
        return data;
    },
    async getFirstClassTypes() {
        const { data } = await AirfareAPI.getFirstClassTypes()
        return data;
    }
}